var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-introduction"},[_c('ProjectHeader',{attrs:{"title":"经典案例","subtitle":"依托先进的成套技术服务能力和资深的项目实施经验，我们为各类文物与遗产保护提供全方位的保护与数字化应用服务。"}}),_c('div',{staticClass:"projects-container"},_vm._l((_vm.projects),function(project,index){return _c('ProjectCard',{key:index,attrs:{"project":project}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }